module.exports = __webpack_public_path__ + "img/callMe.a0d9863d.png";